module.exports = __webpack_public_path__ + "img/sup_withdraw_crypto2.79518eac.jpg";